// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-slide-group[data-v-0ce27e17] .v-slide-group__content{place-content:center}.product-suggestions[data-v-0ce27e17] .v-btn{height:42px!important}.product-discount-tag[data-v-0ce27e17]{position:absolute;top:0;left:0;color:#fff;z-index:1}", ""]);
// Exports
module.exports = exports;
